module.exports = __webpack_public_path__ + "img/Impact assessment-Monitoring plan.08b6becc.svg";